export default "__VITE_ASSET__DdHDiBU$__"